import * as styles from './AuditItemsFilters.css';

interface FilterActionsProps {
  filtersActive: boolean;
  activeFilterCount: number;
  isLoading: boolean;
  onClearAllFilters: () => void;
}

/**
 * Filter actions component with active filters indicator and clear button
 * Shows count of active filters and provides clear all functionality
 */
export function FilterActions({ filtersActive, activeFilterCount, isLoading, onClearAllFilters }: FilterActionsProps) {
  return (
    <div className={styles.filterActions}>
      {filtersActive && (
        <div className={styles.activeFiltersIndicator}>
          {activeFilterCount} filter{activeFilterCount !== 1 ? 's' : ''} active
        </div>
      )}

      <button className={styles.clearFiltersButton} disabled={!filtersActive || isLoading} type="button" onClick={onClearAllFilters}>
        Clear All Filters
      </button>
    </div>
  );
}
